import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Public pages
import Home from "../pages/Home";
import SignIn from "../pages/auth/SignIn";
import SignUp from "../pages/auth/SignUp";

// Dashboard layout + subpages
import Dashboard from "../pages/dashboard/Dashboard";
import Vehicles from "../pages/dashboard/Vehicles";
import Trips from "../pages/dashboard/Trips";
import Reports from "../pages/dashboard/Reports";
import Settings from "../pages/dashboard/Settings";
import LiveMap from "../pages/dashboard/LiveMap";

// Auth protection
import PrivateRoute from "./PrivateRoute";
 
const AppRoutes = ({ theme, scrollTo }) => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Home theme={theme} scrollTo={scrollTo} />} />
      <Route path="/auth/signin" element={<SignIn />} />
      <Route path="/auth/signup" element={<SignUp />} />

      {/* Protected Dashboard Routes */}
      <Route element={<PrivateRoute />}>
        <Route path="/dashboard" element={<Dashboard />}>
          {/* 👇 Default child route when only /dashboard is hit */}
          <Route index element={<Navigate to="vehicles" replace />} />
          <Route path="vehicles" element={<Vehicles />} />
          <Route path="trips" element={<Trips />} />
          <Route path="reports" element={<Reports />} />
          <Route path="settings" element={<Settings />} />
          <Route path="map" element={<LiveMap />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default AppRoutes;
